/** Compact dollar formatting shared across dashboard widgets ($17.9k / $325 / -$500). */
export function formatMoney(value: number): string {
  const abs = Math.abs(value)
  const formatted = abs >= 1000 ? `$${(abs / 1000).toFixed(1)}k` : `$${Math.round(abs)}`
  return value < 0 ? `-${formatted}` : formatted
}

const exactFormatter = new Intl.NumberFormat('en-AU', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

/** Exact dollars and cents ($17,885.83 / -$500.00) — for amounts the user acts on. */
export function formatMoneyExact(value: number): string {
  const num = Number(value)
  if (!Number.isFinite(num)) return ''
  const formatted = `$${exactFormatter.format(Math.abs(num))}`
  return num < 0 ? `-${formatted}` : formatted
}
